import clsx from 'clsx';
import React from 'react';

import { User } from '../../../../utils/backend-api/currentUser';
import UserAvatar, { AvatarSizes } from '../../../User/UserAvatar';
import UserBylines from '../../../User/UserBylines';
import UserProfileLink from '../../../User/UserProfileLink';
import styles from './styles.module.css';

export default function TopicPostAuthor({ author }: { author: User }) {
  return (
    <div className={clsx(styles.bylineWithHeadshots)}>
      <UserProfileLink user={author}>
        <UserAvatar user={author} grow={false} size={AvatarSizes.Medium} />
      </UserProfileLink>
      <UserBylines user={author} />
    </div>
  );
}
